import React from "react";
import { Button, NumberInput, required, TextInput, useNotify } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const EditMidSemesterGradeDialog = ({
  studentEducationId,
  disciplineId,
  midSemesterGradeId,
  fetchMidSemesterGrades,
}) => {
  const notify = useNotify();

  const handleConfirm = async ({ grade, comment }) => {
    const payload = {
      grade: Number(grade),
      comment: comment?.trim() || null,
    };
    await dataProvider.customRequest(
      studentRequests.updateMidSemesterGrade(studentEducationId, disciplineId, midSemesterGradeId),
      payload,
      "PUT",
    );
    notify("Успешно редактиране на междинна оценка", { type: "success" });
    fetchMidSemesterGrades();
  };

  return (
    <FormModal
      titleContent="Редактирай междинна оценка"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Редактирай"
          startIcon={<EditIcon />}
          variant="contained"
          size="small"
        />
      }
    >
      <Grid
        container
        columnSpacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            source="grade"
            label="Оценка"
            min={2}
            max={6}
            step={0.01}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
        >
          <TextInput
            source="comment"
            label="Описание"
            fullWidth
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default EditMidSemesterGradeDialog;
